module.exports = __webpack_public_path__ + "static/img/small_loading.12be8cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/small_loading.gif
// module id = T/FF
// module chunks = 40